<template>
  <div class="banquet-chat">
    <div class="ui vertical top loader" :class="{'active': getBanquetForm.waiting}"></div>

    <div class="ui stackable grid">

      <div class="eight wide column chat-column">
        <div class="chatItemContainer">

          <div v-for="comment in comments" :key="comment.id" class="comment">
            <div v-if="comment.is_own && (comment.text || comment.attachment)" class="chatItem">
              <div class="chatItem__talk chatItem__talk--self">
                <div class="chatItem__talkMainContainer">
                  <div class="chatItem__balloon chatItem__balloon--self">
                    <div v-if="comment.text" class="chatItem__text linebreak" v-html="$options.filters.urlize(comment.text)"></div>
                    <div v-if="comment.attachment" class="chatItem__text">
                      <a :href="comment.attachment.urls.original" target="_blank">{{ comment.attachment.original_file_name }}</a>
                    </div>
                  </div>
                  <div class="chatItem__metaContainer chatItem__metaContainer--self">
                    <a @click="deleteComment(comment)">削除する</a>
                  </div>
                  <div class="chatItem__metaContainer chatItem__metaContainer--self">
                    <span class="chatItem__readStatus" v-show="comment.read">既読</span>
                    <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="comment.text && comment.variant === 'rectangle'" class="chatItem">
              <div class="chatItem__shopActionResult linebreak">
                {{ comment.text }}
              </div>
            </div>

            <div v-else-if="comment.json && comment.json.type === 'RESERVATION_OK'" class="chatItem">
              <div class="chatItem__shopActionResult">
                [空席あり]<br>
                お席のご用意が可能です。<br>
                ご予約は本チャットにてご依頼ください。
              </div>
            </div>
            <div v-else-if="comment.json && comment.json.type === 'RESERVATION_OK_WITH_CONSULT'" class="chatItem">
              <div class="chatItem__shopActionResult">
                [空席あり]<br>
                お席のご用意が可能ですが、会場様とご相談が必要です。<br>
                条件をこちらのチャットでご確認ください。
              </div>
            </div>
            <div v-else-if="comment.json && comment.json.type === 'RESERVATION_NG'" class="chatItem">
              <div class="chatItem__shopActionResult">
                [空席なし]<br>
                ご指定の条件ではお席をご用意できません。<br>
                本チャットにて別な条件で空席の有無をご確認いただけます。
              </div>
            </div>

            <div v-else-if="comment.json && comment.json.type === 'COMMIT_RESERVATION'" class="chatItem">
              <div class="chatItem__shopActionResult">予約を受付ました。</div>
            </div>
            <div v-else-if="comment.json && comment.json.type === 'EDIT_RESERVATION'" class="chatItem">
              <div class="chatItem__shopActionResult">予約が変更されました。</div>
            </div>
            <div v-else-if="comment.json && comment.json.type === 'CANCEL_RESERVATION'" class="chatItem">
              <div class="chatItem__shopActionResult">予約がキャンセルされました。</div>
            </div>

            <div v-else class="chatItem">
              <div class="chatItem__talk chatItem__talk--peer">
                <div class="chatItem__talkMainContainer chatItem__talkMainContainer--peer">
                  <div class="chatItem__balloon chatItem__balloon--peer">
                    <div v-if="comment.text" class="chatItem__text linebreak" v-html="$options.filters.urlize(comment.text)"></div>
                  </div>
                  <div class="chatItem__metaContainer chatItem__metaContainer--peer">
                    <span class="chatItem__timestamp">{{ comment.created_at | formatDatetime }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <form v-if="banquet" class="ui form chatForm" @submit.prevent="postChatComment()">
          <div class="field">
            <textarea v-model.trim="commentForm.model.text" rows="3" :disabled="banquet.status === 'requested'"></textarea>
          </div>
          <div class="chatForm__actions">
            <s3 v-model="commentForm.model.attachment" :accept="'image/*,application/pdf'"></s3>
            <button type="submit" class="ui primary tiny right floated button" :disabled="banquet.status === 'requested'" :class="{'loading': commentForm.waiting}">送信する</button>
          </div>
        </form>
      </div>

      <div class="eight wide column action-column" v-if="banquet">
        <div class="statusContainer">
          <h3>ステータス</h3>
          <table class="ui definition keyValueTable table">
            <tr>
              <td>ステータス</td>
              <td>
                {{ banquet.status_label }} &nbsp;
                <button v-if="banquet.status === 'requested' || banquet.status === 'active' || banquet.status === 'ng'" type="button" class="ui tiny orange button" @click="openReplyDialog()">空席の有無を変更する</button>
                <div style="margin-top: 12px;">
                  <button v-if="banquet.status === 'requested' || banquet.status === 'active' || banquet.status === 'reserved'" type="button" class="ui tiny positive button" @click="openRegisterContractDialog()">実施済み</button>
                  <button v-if="banquet.status === 'closed'" type="button" class="ui tiny positive button" @click="openContractDialog()">成約金額を確認する</button>
                  <button v-if="banquet.status === 'requested' || banquet.status === 'active' || banquet.status === 'ng'" type="button" class="ui tiny button" @click="cancel">成約せず</button>
                </div>
                <div style="margin-top: 12px;" v-if="banquet.status === 'canceled'">
                  <button type="button" class="ui tiny positive button" @click="restoreToActive">チャット中に戻す</button>
                </div>
              </td>
            </tr>
            <tr v-if="banquet.status !== 'reserved' && banquet.status !== 'closed'">
              <td>予約承認</td>
              <td>
                <div v-if="banquet.status === 'requested' || banquet.status === 'canceled'">
                  <div v-if="banquet.status === 'requested'" class="ui warning mini message">「空席あり」のご連絡後に予約承認が可能となります</div>
                  <button class="ui green tiny button disabled">予約承認</button>
                </div>
                <div v-else-if="banquet.status === 'active'">
                  <div class="ui warning mini message">
                    お客様から予約希望を受けましたら、予約承認ボタンを押してください。
                  </div>
                  <button type="button" @click="openReserveDialog" class="ui green tiny button">予約承認</button>
                </div>
              </td>
            </tr>
            <tr>
              <td>コンシェルジュからの<br>申し送り事項</td>
              <td class="linebreak">{{ banquet.marunage.message_for_shop }}</td>
            </tr>
            <tr>
              <td>立候補</td>
              <td>
                <a v-if="banquet.candidate" :href="banquet.candidate.candiate_page_url">
                  立候補済み
                </a>
              </td>
            </tr>
          </table>
          <div v-if="banquet.status === 'reserved'">
            <button type="button" @click="openEditReservationDialog" class="ui green tiny button">予約変更</button>
            <button type="button" class="ui tiny red button" @click="cancel">予約をキャンセルする</button>
          </div>
          <h3>お客様情報</h3>
          <table class="ui definition keyValueTable table">
            <tr>
              <td>会社・団体 / 個人</td>
              <td>{{ banquet.marunage.is_company ? '会社・団体' : '個人' }}</td>
            </tr>
            <tr v-if="banquet.marunage.is_company">
              <td>会社名・団体名</td>
              <td>{{ banquet.marunage.company_name }}</td>
            </tr>
            <tr>
              <td>お名前(カナ)</td>
              <td>{{ banquet.marunage.name_kana || '(未設定)' }}</td>
            </tr>
            <tr>
              <td>お名前</td>
              <td>{{ banquet.marunage.name }}</td>
            </tr>
            <template v-if="['active', 'reserved', 'closed'].includes(banquet.status)">
              <tr>
                <td>メールアドレス</td>
                <td v-if="banquet.is_email_confirmed">
                  <span>※メールアドレス確認済み</span>
                  <div class="ui positive large message" style="margin-top: 0;">
                    <span>{{ banquet.marunage.email || '(未設定)' }}</span>
                  </div>
                </td>
                <td v-else>
                  <button type="button" class="ui orange button" @click="openEMailDialog()">メールアドレスを確認する</button>
                </td>
              </tr>
              <tr>
                <td>電話番号</td>
                <td v-if="banquet.is_tel_confirmed">
                  <span>※電話番号確認済み</span>
                  <div class="ui positive large message" style="margin-top: 0;">
                    <span>{{ banquet.marunage.tel || '(未設定)' }}</span>
                  </div>
                </td>
                <td v-else>
                  <button type="button" class="ui orange button" @click="openTelDialog()">電話番号を確認する</button>
                </td>
              </tr>
            </template>
          </table>
          <h3>ご利用情報</h3>
          <table class="ui definition keyValueTable table">
            <tr>
              <td>利用カテゴリ</td>
              <td>{{ banquet.marunage.category_label }}</td>
            </tr>
            <tr>
              <td>利用主旨</td>
              <td>{{ banquet.marunage.purpose }}</td>
            </tr>
            <tr v-if="banquet.reservation">
              <td>予約日時</td>
              <td>
                {{ banquet.reservation.event_date | formatDate }} {{ banquet.reservation.event_time }}
              </td>
            </tr>
            <tr v-else>
              <td>利用日時</td>
              <td>{{ banquet.marunage.event_date | formatDate }} {{ banquet.marunage.event_time }}</td>
            </tr>
            <tr>
              <td>日時の変更可否</td>
              <td>{{ banquet.marunage.is_event_datatime_flexible ? '（可）' : '（不可）' }} {{ banquet.marunage.event_datetime_memo }}</td>
            </tr>
            <tr v-if="banquet.reservation">
              <td>予約人数</td>
              <td>{{ banquet.reservation.detail_people }}人</td>
            </tr>
            <tr v-else>
              <td>人数</td>
              <td>{{ banquet.marunage.people_label }}</td>
            </tr>
            <tr v-if="banquet.reservation">
              <td>1人あたりの料金</td>
              <td>{{ banquet.reservation.detail_price | formatCurrency }}円</td>
            </tr>
            <tr v-else>
              <td>1人あたりの予算</td>
              <td>{{ banquet.marunage.price_label }}</td>
            </tr>
            <tr v-if="banquet.reservation && banquet.reservation.course">
              <td>プラン</td>
              <td>{{ banquet.reservation.course.name }}</td>
            </tr>
            <tr v-else-if="!banquet.reservation && banquet.course">
              <td>希望プラン</td>
              <td>{{ banquet.course.name }}</td>
            </tr>
            <tr v-if="banquet.reservation && banquet.reservation.meeting">
              <td>プラン</td>
              <td>{{ banquet.reservation.meeting.name }}</td>
            </tr>
            <tr v-else-if="!banquet.reservation && banquet.meeting">
              <td>希望プラン</td>
              <td>{{ banquet.meeting.name }}</td>
            </tr>
            <tr v-if="banquet.reservation && banquet.reservation.lodge_meeting">
              <td>プラン</td>
              <td>{{ banquet.reservation.lodge_meeting.name }}</td>
            </tr>
            <tr v-else-if="!banquet.reservation && banquet.lodge_meeting">
              <td>希望プラン</td>
              <td>{{ banquet.lodge_meeting.name }}</td>
            </tr>
            <tr>
              <td>予算の変更可否</td>
              <td>{{ banquet.marunage.is_price_flexible ? '（可）' : '（不可）' }} {{ banquet.marunage.price_memo }}</td>
            </tr>
            <tr>
              <td>レイアウト希望</td>
              <td>{{ banquet.marunage.seat_preference_label }}</td>
            </tr>
            <tr>
              <td>会議室のご利用</td>
              <td>{{ banquet.marunage.use_meeting_room_label }}</td>
            </tr>
            <tr>
              <td>設備・サービス</td>
              <td v-if="banquet.marunage.use_facilities.length > 0 && banquet.marunage.use_facilities_memo">
                {{ banquet.marunage.use_facilities.join('、') }}<br>{{ banquet.marunage.use_facilities_memo }}
              </td>
              <td v-else-if="banquet.marunage.use_facilities.length > 0">
                {{ banquet.marunage.use_facilities.join('、') }}
              </td>
              <td v-else-if="banquet.marunage.use_facilities_memo">
                {{ banquet.marunage.use_facilities_memo }}
              </td>
              <td v-else>
                (未設定)
              </td>
            </tr>
            <tr>
              <td>その他希望条件</td>
              <td>{{ banquet.marunage.note || '(未設定)' }}</td>
            </tr>
          </table>
        </div>
      </div>

    </div>

    <div id="reply-dialog" class="ui small modal">
      <i class="close icon"></i>
      <div class="header">空きの有無を連絡する</div>
      <div class="scrolling content">
        <table class="ui definition keyValueTable table replyTable" v-if="banquet">
          <tr>
            <td>ステータス</td>
            <td>{{ banquet.status_label }}</td>
          </tr>
          <tr>
            <td>区分</td>
            <td>{{ banquet.marunage.is_company ? '会社・団体' : '個人' }}</td>
          </tr>
          <tr v-if="banquet.marunage.is_company">
            <td>会社名・団体名</td>
            <td>{{ banquet.marunage.company_name }}</td>
          </tr>
          <tr>
            <td>お名前</td>
            <td>{{ banquet.marunage.name || '(未設定)' }}</td>
          </tr>
          <tr>
            <td>お名前(カナ)</td>
            <td>{{ banquet.marunage.name_kana || '(未設定)' }}</td>
          </tr>
        </table>

        <table class="ui definition keyValueTable table replyTable" v-if="banquet">
          <tr>
            <td>利用カテゴリ</td>
            <td>{{ banquet.marunage.category_label }}</td>
          </tr>
          <tr>
            <td>利用主旨</td>
            <td>{{ banquet.marunage.purpose }}</td>
          </tr>
          <tr v-if="banquet.marunage.usage_type === 'meeting'">
            <td>利用種別</td>
            <td>会議・イベント</td>
          </tr>
          <tr v-else>
            <td>利用種別</td>
            <td>宴会・パーティ</td>
          </tr>
          <tr>
            <td>希望日時</td>
            <td>{{ banquet.marunage.event_date | formatDate }} {{ banquet.marunage.event_time }}</td>
          </tr>
          <tr>
            <td>日時の変更可否</td>
            <td>{{ banquet.marunage.is_event_datatime_flexible ? '（可）' : '（不可）' }}</td>
          </tr>
          <tr>
            <td>日時の変更可否：コメント</td>
            <td>{{ banquet.marunage.event_datetime_memo || '(未設定)' }}</td>
          </tr>
          <tr>
            <td>人数</td>
            <td>{{ banquet.marunage.people_label }}</td>
          </tr>
          <tr>
            <td>立食・着席希望</td>
            <td>{{ banquet.marunage.seat_preference_label }}</td>
          </tr>
          <tr>
            <td>会議室のご利用</td>
            <td>{{ banquet.marunage.use_meeting_room_label }}</td>
          </tr>
          <tr v-if="banquet.marunage.price_label">
            <td>一人当たりの予算</td>
            <td>{{ banquet.marunage.price_label }}</td>
          </tr>
          <tr v-if="banquet.marunage.total_price">
            <td>総予算</td>
            <td>{{ banquet.marunage.total_price }}円</td>
          </tr>
          <tr>
            <td>予算の変更可否</td>
            <td>{{ banquet.marunage.is_price_flexible ? '（可）' : '（不可）' }}</td>
          </tr>
          <tr>
            <td>予算の変更可否：コメント</td>
            <td>{{ banquet.marunage.price_memo || '(未設定)' }}</td>
          </tr>
          <tr v-if="banquet.course">
            <td>希望プラン</td>
            <td>{{ banquet.course.name }}</td>
          </tr>
          <tr v-if="banquet.meeting">
            <td>希望プラン</td>
            <td>{{ banquet.meeting.name }}</td>
          </tr>
          <tr v-if="banquet.lodge_meeting">
            <td>希望プラン</td>
            <td>{{ banquet.lodge_meeting.name }}</td>
          </tr>
          <tr>
            <td>設備・サービス</td>
            <td v-if="banquet.marunage.use_facilities.length">{{ banquet.marunage.use_facilities.join('、') }}</td>
            <td v-else>(未設定)</td>
          </tr>
          <tr>
            <td>希望条件など</td>
            <td class="linebreak">{{ banquet.marunage.note }}</td>
          </tr>
          <tr>
            <td>コンシェルジュからの<br>申し送り事項</td>
            <td class="linebreak">{{ banquet.marunage.message_for_shop }}</td>
          </tr>
        </table>
        <div class="ui clearing divider"></div>
        <form class="ui form replyTemplateForm" :class="{'warning': replyForm.hasError()}">
          <div class="required field">
            <label>空席状況</label>
            <div class="ui checkbox radio">
              <input type="radio" v-model="replyForm.model.accept_type" value="OK" @change="changeAccept">
              <label>空きあり</label>
            </div>
            <div class="ui checkbox radio">
              <input type="radio" v-model="replyForm.model.accept_type" value="OK_WITH_CONSULT" @change="changeAccept">
              <label>空きあり（要相談）</label>
            </div>
            <div class="ui checkbox radio">
              <input type="radio" v-model="replyForm.model.accept_type" value="NG" @change="changeAccept">
              <label>空きなし</label>
            </div>
            <validation-message :form="replyForm" field="accept_type"></validation-message>
          </div>
          <div class="field">
            <label>返信テンプレート選択（任意）<span>テンプレート登録は<a href="/shopadmin/reply_templates">こちら</a>から</span></label>
            <dropdown v-model="replyForm.model.reply_template_id" @change="onReplyTemplateChange()" placeholder="指定しない">
                <option value=""></option>
              <option v-for="each in reply_templates" :key="each.id" :value="each.id">
                {{ each.name }}
              </option>
            </dropdown>
          </div>
          <div class="required field">
            <label>メッセージ</label>
            <textarea v-model="replyForm.model.message" type="text" rows="5" :placeholder="replyMessagePlaceholder"></textarea>
            <validation-message :form="replyForm" :field="'message'"></validation-message>
          </div>
        </form>
      </div>
      <div class="actions">
        <div class="ui cancel button">閉じる</div>
        <div class="ui green button" :class="{'loading disabled': replyForm.waiting}" @click="reply()">送信する</div>
      </div>
    </div>

    <div id="reserve-dialog" class="ui tiny modal">
      <i class="close icon"></i>
      <div class="header">予約情報を入力してください</div>
      <div class="scrolling content" style="min-height: 400px;">
        <form class="ui form" :class="{warning: reserveForm.hasErrors()}">
          <div class="two fields">
            <div class="required field">
              <label>希望日</label>
              <datepick v-model="reserveForm.model.event_date" :from="1" :placeholder="'希望日'"></datepick>
              <validation-message :form="reserveForm" :field="'event_date'"></validation-message>
            </div>
            <div class="required field">
              <label>希望時間</label>
              <dropdown v-model="reserveForm.model.event_time" :options="consts.MARUNAGE_EVENT_TIME" :placeholder="'希望時間'"></dropdown>
              <validation-message :form="reserveForm" :field="'event_time'"></validation-message>
            </div>
          </div>
          <div class="field">
            <label>プラン <small>(特別プランをご提供の場合はプランの選択は必要ありません)</small></label>
            <div v-if="canChoosePlan" style="margin-bottom: 10px;">
              <div class="ui checkbox radio" v-if="banquet.shop && banquet.shop.courses.length > 0">
                <input type="radio" id="courses" v-model="selectedPlanType" name="plan_type" :value="consts.PLAN_TYPE_TO_VALUE.course">
                <label for="courses" style="cursor: pointer;">宴会</label>
              </div>
              <div class="ui checkbox radio" v-if="banquet.shop && banquet.shop.meetings.length > 0">
                <input type="radio" id="meetings" v-model="selectedPlanType" name="plan_type" :value="consts.PLAN_TYPE_TO_VALUE.meeting">
                <label for="meetings" style="cursor: pointer;">会議室</label>
              </div>
              <div class="ui checkbox radio" v-if="banquet.shop && banquet.shop.lodge_meetings.length > 0">
                <input type="radio" id="lodge-meetings" v-model="selectedPlanType" name="plan_type" :value="consts.PLAN_TYPE_TO_VALUE.lodgeMeeting">
                <label for="lodge-meetings" style="cursor: pointer;">宿泊会議</label>
              </div>
            </div>
            <div v-if="selectedPlanType === consts.PLAN_TYPE_TO_VALUE.course" class="field">
              <dropdown v-model="reserveForm.model.course_id" :placeholder="'プラン'">
                <option value="">-----</option>
                <option v-for="course in banquet.shop.courses" :value="course.id" :key="consts.PLAN_TYPE_TO_VALUE.course + course.id">{{ course.name }}</option>
              </dropdown>
              <validation-message :form="reserveForm" :field="'course_id'"></validation-message>
            </div>
            <div v-if="selectedPlanType === consts.PLAN_TYPE_TO_VALUE.meeting" class="field">
              <dropdown v-model="reserveForm.model.meeting_id" :placeholder="'プラン'">
                <option value="">-----</option>
                <option v-for="meeting in banquet.shop.meetings" :value="meeting.id" :key="consts.PLAN_TYPE_TO_VALUE.meeting + meeting.id">{{ meeting.name }}</option>
              </dropdown>
              <validation-message :form="reserveForm" :field="'meeting_id'"></validation-message>
            </div>
            <div v-if="selectedPlanType === consts.PLAN_TYPE_TO_VALUE.lodgeMeeting" class="field">
              <dropdown v-model="reserveForm.model.lodge_meeting_id" :placeholder="'プラン'">
                <option value="">-----</option>
                <option v-for="lodgeMeeting in banquet.shop.lodge_meetings" :value="lodgeMeeting.id" :key="consts.PLAN_TYPE_TO_VALUE.lodgeMeeting + lodgeMeeting.id">{{ lodgeMeeting.name }}</option>
              </dropdown>
              <validation-message :form="reserveForm" :field="'lodge_meeting_id'"></validation-message>
            </div>
          </div>
          <div class="two fields">
            <div class="required field">
              <label>一人当たりの料金</label>
              <input type="number" v-model="reserveForm.model.detail_price" :placeholder="'一人当たりの料金'">
              <validation-message :form="reserveForm" :field="'detail_price'"></validation-message>
            </div>
            <div class="required field">
              <label>予約人数</label>
              <input type="number" v-model="reserveForm.model.detail_people" :placeholder="'予約人数'">
              <validation-message :form="reserveForm" :field="'detail_people'"></validation-message>
            </div>
          </div>
        </form>
        <div class="ui positive message">お客様から日程変更の連絡を受けた場合は、本管理画面にて日程を再設定してください。</div>
      </div>
      <div class="actions">
        <div class="ui cancel button">閉じる</div>
        <div class="ui green button" :class="{'loading disabled': reserveForm.waiting}" @click="reserve">予約承認</div>
      </div>
    </div>

    <div id="edit-reservation-dialog" class="ui tiny modal">
      <i class="close icon"></i>
      <div class="header">予約情報を入力してください</div>
      <div class="scrolling content" style="min-height: 400px;">
        <form class="ui form" :class="{warning: reserveForm.hasErrors()}">
          <div class="two fields">
            <div class="field">
              <label>希望日</label>
              <datepick v-model="reserveForm.model.event_date" :from="1" :placeholder="'希望日'"></datepick>
              <validation-message :form="reserveForm" :field="'event_date'"></validation-message>
            </div>
            <div class="field">
              <label>希望時間</label>
              <dropdown v-model="reserveForm.model.event_time" :options="consts.MARUNAGE_EVENT_TIME" :placeholder="'希望時間'"></dropdown>
              <validation-message :form="reserveForm" :field="'event_time'"></validation-message>
            </div>
          </div>
          <div class="field">
            <label>プラン</label>
            <div v-if="canChoosePlan" style="margin-bottom: 10px;">
              <div class="ui checkbox radio" v-if="banquet.shop && banquet.shop.courses.length > 0">
                <input type="radio" id="courses" v-model="selectedPlanType" name="plan_type" :value="consts.PLAN_TYPE_TO_VALUE.course">
                <label for="courses" style="cursor: pointer;">宴会</label>
              </div>
              <div class="ui checkbox radio" v-if="banquet.shop && banquet.shop.meetings.length > 0">
                <input type="radio" id="meetings" v-model="selectedPlanType" name="plan_type" :value="consts.PLAN_TYPE_TO_VALUE.meeting">
                <label for="meetings" style="cursor: pointer;">会議室</label>
              </div>
              <div class="ui checkbox radio" v-if="banquet.shop && banquet.shop.lodge_meetings.length > 0">
                <input type="radio" id="lodge-meetings" v-model="selectedPlanType" name="plan_type" :value="consts.PLAN_TYPE_TO_VALUE.lodgeMeeting">
                <label for="lodge-meetings" style="cursor: pointer;">宿泊会議</label>
              </div>
            </div>
            <div v-if="selectedPlanType === consts.PLAN_TYPE_TO_VALUE.course" class="field">
              <dropdown v-model="reserveForm.model.course_id" :placeholder="'プラン'">
                <option value="">-----</option>
                <option v-for="course in banquet.shop.courses" :value="course.id" :key="consts.PLAN_TYPE_TO_VALUE.course + course.id">{{ course.name }}</option>
              </dropdown>
              <validation-message :form="reserveForm" :field="'course_id'"></validation-message>
            </div>
            <div v-if="selectedPlanType === consts.PLAN_TYPE_TO_VALUE.meeting" class="field">
              <dropdown v-model="reserveForm.model.meeting_id" :placeholder="'プラン'">
                <option value="">-----</option>
                <option v-for="meeting in banquet.shop.meetings" :value="meeting.id" :key="consts.PLAN_TYPE_TO_VALUE.meeting + meeting.id">{{ meeting.name }}</option>
              </dropdown>
              <validation-message :form="reserveForm" :field="'meeting_id'"></validation-message>
            </div>
            <div v-if="selectedPlanType === consts.PLAN_TYPE_TO_VALUE.lodgeMeeting" class="field">
              <dropdown v-model="reserveForm.model.lodge_meeting_id" :placeholder="'プラン'">
                <option value="">-----</option>
                <option v-for="lodgeMeeting in banquet.shop.lodge_meetings" :value="lodgeMeeting.id" :key="consts.PLAN_TYPE_TO_VALUE.lodgeMeeting + lodgeMeeting.id">{{ lodgeMeeting.name }}</option>
              </dropdown>
              <validation-message :form="reserveForm" :field="'lodge_meeting_id'"></validation-message>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label>一人当たりの料金</label>
              <input type="number" v-model="reserveForm.model.detail_price" :placeholder="'一人当たりの料金'">
              <validation-message :form="reserveForm" :field="'detail_price'"></validation-message>
            </div>
            <div class="field">
              <label>予約人数</label>
              <input type="number" v-model="reserveForm.model.detail_people" :placeholder="'予約人数'">
              <validation-message :form="reserveForm" :field="'detail_people'"></validation-message>
            </div>
          </div>
        </form>
      </div>
      <div class="actions">
        <div class="ui cancel button">閉じる</div>
        <div class="ui green button" :class="{'loading disabled': reserveForm.waiting}" @click="editReservation">予約情報を変更する</div>
      </div>
    </div>

    <div id="register-contract-dialog" class="ui small modal">
      <i class="close icon"></i>
      <div class="header">来場確認・成約金額登録</div>
      <div class="scrolling content" style="min-height: 400px;">
        <div class="ui negative message">※ご利用金額に応じて、お客様へギフト券をプレゼントしています。<br>正確にご入力をお願いいたします。</div>
        <form class="ui form contractForm" :class="{warning: registerContractForm.hasErrors()}">
          <div class="contractForm__contentTitleContainer">
            <h3 class="contractForm__contentTitle">宴会の実施内容</h3>
          </div>
          <div class="two fields" style="flex-wrap: nowrap;">
            <div class="required field">
              <label>実施日</label>
              <datepick v-model="registerContractForm.model.event_date" :placeholder="'実施日'"></datepick>
              <validation-message :form="registerContractForm" :field="'event_date'"></validation-message>
            </div>
            <div class="required field">
              <label>実施時間</label>
              <dropdown v-model="registerContractForm.model.event_time" :options="consts.MARUNAGE_EVENT_TIME" :placeholder="'実施時間'"></dropdown>
              <validation-message :form="registerContractForm" :field="'event_time'"></validation-message>
            </div>
          </div>
          <div class="two fields" style="flex-wrap: nowrap;">
            <div class="required field">
              <label>コース料金(お一人様)</label>
              <input type="number" v-model="registerContractForm.model.detail_price" :placeholder="'コース料金(お一人様)'">
              <validation-message :form="registerContractForm" :field="'detail_price'"></validation-message>
            </div>
            <div class="required field">
              <label>実施人数</label>
              <input type="number" v-model="registerContractForm.model.detail_people" :placeholder="'実施人数'">
              <validation-message :form="registerContractForm" :field="'detail_people'"></validation-message>
            </div>
          </div>
          <div class="required eight wide field">
            <label>コース料金総額(税込)</label>
            <input type="text" :value="totalCoursePrice.toLocaleString()" :placeholder="'コース料金総額(税込)'" disabled>
          </div>
          <div class="contractForm__contentTitleContainer">
            <h3 class="contractForm__contentTitle">その他のご利用金額</h3>
            <p>延長料金、会議利用料、備品などをご入力ください。</p>
          </div>
          <div class="fields" v-for="(item, index) in registerContractForm.model.optional_items" :key="index">
            <div class="field seven wide">
              <label :class="{'contractForm__optionalInputLabel': index !== 0}">項目</label>
              <input class="contractForm__OptionalInputField" type="text" v-model="item.name" :placeholder="'マイク利用貸与料金'">
                <validation-message :form="registerContractForm" :field="'optional_items'" :subField="'name'" :index="index"></validation-message>
            </div>
            <div class="field seven wide">
              <label :class="{'contractForm__optionalInputLabel': index !== 0}">金額</label>
              <input class="contractForm__OptionalInputField" type="number" v-model="item.price" :placeholder="'10,000'">
              <validation-message :form="registerContractForm" :field="'optional_items'" :subField="'price'" :index="index"></validation-message>
            </div>
            <div v-if="index !== 0 && (registerContractForm.model.optional_items.length - 1) === index"
                 class="field contractForm__optionalButtonContainer pcOnly">
              <button type="button" class="ui tiny red button icon" @click="removeOtherItem(index)">
                <i class="trash alternate outline icon"></i>
              </button>
            </div>
          </div>
          <div class="field fourteen wide contractForm__optionalButtonContainer pcOnly">
            <button type="button" class="ui button icon" @click="addOtherItem">
              <i class="clickable plus icon"></i> 追加する
            </button>
          </div>
          <div class="field contractForm__optionalButtonContainerMobile spOnly">
            <button type="button" class="ui tiny button icon" @click="addOtherItem">
              <i class="clickable plus icon"></i> 追加する
            </button>
            <button v-if="registerContractForm.model.optional_items.length > 1" type="button" class="ui tiny red button icon" @click="removeOtherItem(index)">
              <i class="trash alternate outline icon"></i>
            </button>
          </div>
          <div class="two fields">
            <div class="required field eight wide">
              <label>お支払い総額計(税込)</label>
              <input type="text" :value="totalPrice.toLocaleString()" :placeholder="'お支払い総額計(税込)'" disabled>
            </div>
          </div>
          <div class="contractForm__contentTitleContainer">
            <h3 class="contractForm__contentTitle">レシート添付</h3>
          </div>
          <div class="fields">
            <div class="required field sixteen wide">
              <p>レシート、もしくは金額の内容がわかるものを添付ください。</p>
              <s3 v-model="registerContractForm.model.receipt_image" :accept="'image/*,application/pdf'"></s3>
              <validation-message :form="registerContractForm" :field="'receipt_image'"></validation-message>
              <p style="margin-top: 5px;">※JPEG、PNG、PDFのみ</p>
            </div>
          </div>
        </form>
        <div class="ui positive message">
          請求に関して不明点がある場合は、以下までご連絡ください。<br><br><br>
          【グルプラサポート（株式会社オールフィット）】<br>
          メールアドレス：info@gourmetplus.jp<br>
          電話番号：0422-24-9496
        </div>
      </div>
      <div class="actions">
        <div class="ui cancel button">閉じる</div>
        <div class="ui green button" :class="{'loading disabled': registerContractForm.waiting}" @click="registerContract">金額を登録する</div>
      </div>
    </div>

    <div id="contract-dialog" class="ui small modal">
      <i class="close icon"></i>
      <div class="header">来場確認・成約金額登録</div>
      <div class="scrolling content" style="min-height: 400px;">
        <form class="ui form contractForm" v-if="contract">
          <div class="contractForm__contentTitleContainer">
            <h3 class="contractForm__contentTitle">宴会・会議の実施内容</h3>
          </div>
          <div class="two fields" style="flex-wrap: nowrap;">
            <div class="required field">
              <label>実施日</label>
              <p class="contractForm__viewContent">{{ contract.event_date.toLocaleString() }}</p>
            </div>
            <div class="required field">
              <label>開始時間</label>
              <p class="contractForm__viewContent">{{ contract.event_time }}</p>
            </div>
          </div>
          <div class="two fields" style="flex-wrap: nowrap;">
            <div class="required field">
              <label>コース料金(お一人様)</label>
              <p class="contractForm__viewContent">{{ contract.detail_price  | formatCurrency }}</p>
            </div>
            <div class="required field">
              <label>実施人数</label>
              <p class="contractForm__viewContent">{{ contract.detail_people }}</p>
            </div>
          </div>
          <div class="required field">
            <label>コース料金総額(税込)</label>
              <p class="contractForm__viewContent">{{ contract.total_course_price  | formatCurrency }}</p>
          </div>
          <div class="contractForm__contentTitleContainer">
            <h3 class="contractForm__contentTitle">その他のご利用金額</h3>
          </div>
           <div v-if="contract.optional_items.length === 0" class="fields">
              <div class="field seven wide contractForm__OptionalInputField">
                <label>項目</label>
              </div>
              <div class="field seven wide contractForm__OptionalInputField">
                <label>金額</label>
              </div>
           </div>
          <div class="fields" v-for="(item, index) in contract.optional_items" :key="index">
            <div class="field seven wide contractForm__OptionalInputField">
              <label>項目</label>
              <p class="contractForm__viewContent">{{ item.name }}</p>
            </div>
            <div class="field seven wide contractForm__OptionalInputField">
              <label>金額</label>
              <p class="contractForm__viewContent">{{ item.price  | formatCurrency }}</p>
            </div>
          </div>
          <div class="required field sixteen wide" style="margin-top: 40px;">
            <label>お支払い総額計(税込)</label>
            <p class="contractForm__viewContent">{{ contract.total_price  | formatCurrency }}</p>
          </div>
          <div class="contractForm__contentTitleContainer">
            <h3 class="contractForm__contentTitle">レシート</h3>
          </div>
          <div class="fields">
            <div class="field sixteen wide">
              <div class="receiptView">
                <p v-if="!contract.receipt_image" class="contractForm__viewContent">入力なし</p>
                <span v-else-if="contract.receipt_image.mime_type === 'application/pdf'" class="pdfIcon">
                  <i class="fas fa-file-pdf"></i>
                </span>
                <img v-else-if="contract.receipt_image.urls.preview" :src="contract.receipt_image.urls.preview">
                <img v-else-if="contract.receipt_image.urls.small" :src="contract.receipt_image.urls.small">
                <span v-if="contract.receipt_image" class="filename" :title="contract.receipt_image.original_file_name">{{ contract.receipt_image.original_file_name }}</span>
                <button v-if="contract.receipt_image" class="ui mini negative button" type="button" @click="viewReceipt()">確認する</button>
              </div>
            </div>
          </div>
        </form>
        <div class="ui positive message">
          請求に関して不明点がある場合は、以下までご連絡ください。<br><br><br>
          【グルプラサポート（株式会社オールフィット）】<br>
          メールアドレス：info@gourmetplus.jp<br>
          電話番号：0422-24-9496
        </div>
      </div>
      <div class="actions">
        <div class="ui cancel button">閉じる</div>
      </div>
    </div>

    <div id="dialog-show-email" class="ui mini modal">
      <i class="close icon"></i>
      <div class="header">メールアドレス</div>
      <div class="content">
        <p>※メールアドレス確認済み</p>
        <div v-if="banquet" class="ui positive massive message center aligned">
          <span>{{ banquet.marunage.email }}</span>
        </div>
      </div>
      <div class="actions">
        <div class="ui button" @click="reload">閉じる</div>
      </div>
    </div>

    <div id="dialog-show-tel" class="ui mini modal">
      <i class="close icon"></i>
      <div class="header">電話番号</div>
      <div class="content">
        <p>※電話番号確認済み</p>
        <div v-if="banquet" class="ui positive massive message center aligned">
          <span>{{ banquet.marunage.tel }}</span>
        </div>
      </div>
      <div class="actions">
        <div class="ui button" @click="reload">閉じる</div>
      </div>
    </div>

  </div>

</template>

<script>
const MESSAGE_OK =
    'この度は数ある会場の中から当会場へお問い合わせいただき誠にありがとうございます。\n' +
    '現状空きがありご案内が可能でございます。\n\n' +
    'お下見やお打ち合わせなども可能でございますのでこちらのチャットにご返信くださいませ。';

const MESSAGE_NG =
    'この度は数ある会場の中から当会場へお問い合わせいただき誠にありがとうございます。\n' +
    '誠に申し訳ございませんが当会場ではご希望条件に沿うことが難しくなっております。\n\n' +
    'また機会がございましたらお問い合わせのほどお待ちしております。';

export default {
    data: function() {
        return {
            getBanquetForm: this.createForm(),
            pollingForm: this.createForm(),
            replyForm: this.createForm(),
            reserveForm: this.createForm(),
            commentForm: this.createForm(),
            registerContractForm: this.createForm({
                detail_price: null,
                detail_people: '',
                optional_items: [{
                  name: '',
                  price: null
                }]
            }),
            contractForm: this.createForm(),
            $replyModalEl: null,
            $ContractModalEl: null,
            $commentsEl: null,
            banquet: null,
            comments: [],
            selectedPlanType: null,
            contract: null,
            reply_templates: [],

            pager: this.createPager(10),
        };
    },
    created: function() {
        this.getBanquetForm.get('/shopadmin/api/banquets/' + this.pathParams().banquet_id, function(response) {
            this.banquet = response.data;
            this.selectedPlanType = this._initPlanType();
            this.$nextTick(function() {
                if (this.banquet.status === 'requested') {
                    this.openReplyDialog();
                }
            });
            this.createForm().get(this.banquet.chat.chat_comments_api_url, function(response) {
                this.comments = response.data;
                this.markRead();
                this.$nextTick(function() {
                    this.$commentsEl.animate({scrollTop: 65535}, 100);
                });
                this.setInterval(this.fetchComments, 10 * 1000, false);
            });
            this.createForm().get('/shopadmin/api/reply_templates', function(response) {
                _.forEach(response.data, function(each) {
                    this.reply_templates.push(each);
                }.bind(this));
            });
        });
    },
    mounted: function() {
        this.$replyModalEl = $('#reply-dialog');
        this.$registerContractModalEl = $('#register-contract-dialog');
        this.$contractModalEl = $('#contract-dialog');
        this.$commentsEl = $('.chatItemContainer');
        var unwatch = this.$watch('searchForm.model.area', function() {
            if (this.searchForm.model.area) {
                this.currentArea = this.searchForm.model.area;
                unwatch();
            }
        });
        $('.ui.checkbox').checkbox();
    },
    watch: {
        comments: function() {
            _.forEach(this.comments, function(comment) {
                if (_.isString(comment.json)) {
                    comment.json = JSON.parse(comment.json);
                    if (comment.json.type === 'REDIRECT_TO_V1') {
                        window.location.href = 'https://v1.gourmetplus.jp/shopadmin/chat/' + comment.json.original_chat_id;
                    }
                }
            }.bind(this));
        }
    },
    computed: {
        canChoosePlan: function() {
            if (!this.banquet || !this.banquet.shop) {
              return false;
            }
            return (
              this.banquet.shop.courses.length > 0 ||
              this.banquet.shop.meetings.length > 0 ||
              this.banquet.shop.lodge_meetings.length > 0
            );
        },
        totalCoursePrice: function() {
           return Number(this.registerContractForm.model.detail_price) * Number(this.registerContractForm.model.detail_people);
        },
        totalPrice: function() {
          let otherItemsTotalPrice = 0;
          if (this.registerContractForm.model.optional_items) {
              otherItemsTotalPrice = this.registerContractForm.model.optional_items.reduce((total, item)=> {
                  if(item.price !== undefined) {
                      return Number(total) + Number(item.price);
                  } else {
                      return total;
                  }
              }, 0);
          }
          return this.totalCoursePrice + otherItemsTotalPrice;
        },
        replyMessagePlaceholder: function() {
            if (this.replyForm.model.accept_type === 'OK_WITH_CONSULT') {
                return 'この度はお問い合わせいただき誠にありがとうございます。\n\n' +
                  'ご希望のお日にちでお席の用意は可能でございますが、当会場ではご希望日は最低保証料金が○○円のご案内となっております。\n' +
                  'ご予算のご調整は可能でございますでしょうか？';
            }
            return 'メッセージ';
        }
    },
    methods: {
        openReplyDialog: function() {
            this.replyForm = this.createForm({
                accept_type: this.banquet.status !== 'ng' ? 'OK' : 'NG',
                message: this.banquet.status !== 'ng' ? MESSAGE_OK : MESSAGE_NG
            });
            this.$replyModalEl.modal({closable: false}).modal('show');
        },
        openRegisterContractDialog: function() {
            this.registerContractForm.model.event_date = this.banquet.marunage.event_date.replaceAll('-', '/');
            this.registerContractForm.model.event_time = this.banquet.marunage.event_time;
            this.registerContractForm.model.detail_price = Number(this.banquet.marunage.price);
            this.registerContractForm.model.detail_people = Number(this.banquet.marunage.people.split('-')[0]);
            this.$registerContractModalEl.modal({closable: false, autofocus: false}).modal('show');
        },
        openContractDialog: function() {
            this.contractForm.get(this.banquet.contract_api_url, function(response) {
                this.contract = response.data;
                this.contract.event_date = this.contract.event_date.replaceAll('-', '/');
                this.$contractModalEl.modal({closable: false, autofocus: false}).modal('show');
            });
        },
        registerContract: function() {
            this.registerContractForm.model.total_course_price = this.totalCoursePrice;
            this.registerContractForm.model.total_price = this.totalPrice;
            this.registerContractForm.post(this.banquet.contract_api_url, function() {
                window.location.reload();
            });
        },
        addOtherItem: function() {
            this.registerContractForm.model.optional_items.push({name: '', price: null});
        },
        removeOtherItem: function(index) {
            this.registerContractForm.model.optional_items.splice(index, 1);
        },
        viewReceipt: function() {
            this.createForm().get(this.banquet.receipt_api_url, function(response) {
                window.open(response.data['urls']['preview'])
            });
        },
        reply: function() {
            this.replyForm.post(this.banquet.reply_api_url, function() {
                window.location.reload();
            });
        },
        markRead: function() {
            this.createForm().put(this.banquet.chat.chat_comments_read_api_url).then(function() {
                this.fetchUnreadNotifications();
            }.bind(this));
        },
        fetchComments: function(scrollRequired = true) {
            this.pollingForm.get(this.banquet.chat.chat_comments_api_url, function(response) {
                var isUpdated = this.comments.length !== response.data.length;
                this.comments = response.data;
                if (scrollRequired && isUpdated) {
                    this.$nextTick(function() {
                        this.$commentsEl.animate({scrollTop: 65535}, 1000);
                    });
                    this.markRead();
                }
            });
        },
        postChatComment: function() {
            if (!this.commentForm.model.text && !this.commentForm.model.attachment) {
                return;
            }
            this.commentForm.post(this.banquet.chat.chat_comments_api_url, function(response) {
                this.comments.push(response.data);
                this.commentForm.model.text = '';
                this.commentForm.model.attachment = null;
                this.$nextTick(function() {
                    this.$commentsEl.animate({scrollTop: 65535}, 1000);
                });
                this.fetchComments();
            });
        },
        deleteComment(comment) {
            if (!confirm('コメントを削除します。よろしいですか？')) {
                return;
            }
            this.createForm().delete(comment.comment_api_url).then(function() {
                this.fetchComments(false);
            }.bind(this));
        },
        openReserveDialog: function() {
            this.reserveForm.model = _.pick(this.banquet.marunage, ['event_date', 'event_time']);
            this.reserveForm.model.detail_price = this.banquet.marunage.price;
            this.reserveForm.model.detail_people = this.banquet.marunage.people.split('-')[0];
            if (this.banquet.course) {
                this.reserveForm.model.course_id = this.banquet.course.id;
            }
            if (this.banquet.meeting) {
                this.reserveForm.model.meeting_id = this.banquet.meeting.id;
            }
            if (this.banquet.lodge_meeting) {
                this.reserveForm.model.lodge_meeting_id = this.banquet.lodge_meeting.id;
            }
            $('#reserve-dialog').modal({closable: false, autofocus: false}).modal('show');
        },
        reserve: function() {
            this._filterRedundantReserveData();
            this.reserveForm.post(this.banquet.reserve_api_url, function() {
                window.location.reload();
            });
        },
        openEditReservationDialog: function() {
            if (!this.banquet.reservation) {
                return;
            }
            this.reserveForm.model = _.cloneDeep(this.banquet.reservation);
            if (this.banquet.reservation.course) {
                this.reserveForm.model.course_id = this.banquet.reservation.course.id;
                this.selectedPlanType = this.consts.PLAN_TYPE_TO_VALUE.course;
            }
            if (this.banquet.reservation.meeting) {
                this.reserveForm.model.meeting_id = this.banquet.reservation.meeting.id;
                this.selectedPlanType = this.consts.PLAN_TYPE_TO_VALUE.meeting;
            }
            if (this.banquet.reservation.lodge_meeting) {
                this.reserveForm.model.lodge_meeting_id = this.banquet.reservation.lodge_meeting.id;
                this.selectedPlanType = this.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting;
            }
            $('#edit-reservation-dialog').modal({autofocus: false, closable: false}).modal('show');
        },
        editReservation: function() {
            this._filterRedundantReserveData();
            this.reserveForm.put(this.banquet.reserve_api_url, function() {
                window.location.reload();
            });
        },
        openEMailDialog: function() {
            this.confirmEMail();
            $('#dialog-show-email').modal({closable: false}).modal('show');
        },
        openTelDialog: function() {
            this.confirmTel();
            $('#dialog-show-tel').modal({closable: false}).modal('show');
        },
        confirmEMail: function() {
            this.createForm({
                is_email_confirmed: true
            }).put(this.banquet.confirm_api_url);
        },
        confirmTel: function() {
            this.createForm({
                is_tel_confirmed: true
            }).put(this.banquet.confirm_api_url);
        },
        reload: function() {
            window.location.reload();
        },
        cancel: function() {
            if (!confirm('案件をキャンセルします。よろしいですか？')) {
                return;
            }
            this.reserveForm.delete(this.banquet.reserve_api_url, function() {
                window.location.reload();
            });
        },
        restoreToActive: function() {
            this.createForm({
                status: 'active'
            }).put(this.banquet.detail_api_url, function(response) {
                this.banquet.status = response.data.status;
                this.banquet.status_label = response.data.status_label;
                alert('ステータスを更新しました');
            }.bind(this), function() {
                alert('ステータスの更新に失敗しました');
            });
        },
        _initPlanType: function() {
            if (!this.banquet || !this.banquet.shop) {
                return null;
            }
            if (this.banquet.shop.courses.length > 0) {
                return this.consts.PLAN_TYPE_TO_VALUE.course
            }
            if (this.banquet.shop.meetings.length > 0) {
                return this.consts.PLAN_TYPE_TO_VALUE.meeting
            }
            if (this.banquet.shop.lodge_meetings.length > 0) {
                return this.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting
            }
        },
        _filterRedundantReserveData: function() {
            this.reserveForm.model.course_id =
                this.selectedPlanType === this.consts.PLAN_TYPE_TO_VALUE.course
                    ? this.reserveForm.model.course_id
                    : null;
            this.reserveForm.model.meeting_id =
                this.selectedPlanType === this.consts.PLAN_TYPE_TO_VALUE.meeting
                    ? this.reserveForm.model.meeting_id
                    : null;
            this.reserveForm.model.lodge_meeting_id =
                this.selectedPlanType === this.consts.PLAN_TYPE_TO_VALUE.lodgeMeeting
                    ? this.reserveForm.model.lodge_meeting_id
                    : null;
        },
        changeAccept: function() {
            if (this.replyForm.model.accept_type === 'OK') {
                  this.replyForm.model.message = MESSAGE_OK
            } else if (this.replyForm.model.accept_type === 'OK_WITH_CONSULT') {
                this.replyForm.model.message = '';
            } else {
                this.replyForm.model.message = MESSAGE_NG;
            }
            this.replyForm.model.reply_template_id = null;
        },
        onReplyTemplateChange: function() {
            const selectedReplyTemplate = this.reply_templates.find((template) => template.id === this.replyForm.model.reply_template_id);
            if (selectedReplyTemplate) {
                this.replyForm.model.message = selectedReplyTemplate.message;
            }
        }
    }
};
</script>
